import AbstractIceContentController from '../../abstract/ice-content/controller';

class Controller extends AbstractIceContentController {

    constructor(widget) {
        super(widget);
        this.init(widget);
    }

    init(widget) {
        document.getElementById('main').setAttribute('x-ms-format-detection', 'none');
        const btnShowModal = document.getElementById('showFaq');
        const mainContent = $('.form-application-page>#main');


        $(btnShowModal).click(function () {
            const modalData = {
                "content": "",
                "isIce": true,
                "size": "fullscreen",
                "disableScroll": true,
                "showCloseIcon": true,
                "showButton": true
            };
            App.PubSub.publish("faqModal", modalData);
        });

        const mMQ = window.matchMedia("(max-width: 700px)");
        matchScreen(mMQ);

        window.addEventListener('change', (e) => {
            matchScreen(mMQ);
        });

        function matchScreen(mMQ) {
            if (mMQ.matches) { //mobile
                document.getElementById("span-separator").style.display = "none";
                mainContent.css('height', 'calc(100% - 461px)');
            } else { //not mobile
                mainContent.css('height', 'calc(100% - 193px)');
            }

            $('.widget-compact-footer__text').html(function (i, html) {
                return html.replace(/(\d)/g, '<span>$1</span>');
            });
        }

        // Resize footer when changing view
        var timeoutWait;
        const delayInt = 200;
        $(window).resize(function (e) {
            clearTimeout(timeoutWait);
            timeoutWait = setTimeout(function () {
                matchScreen(mMQ);
            }, delayInt);
        });
    }
}

export default Controller;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/widgets/widget-compact-footer/scripts/controller.js